export const braindaterContext = 'people';
export const keywordContext = 'keywords';
export const marketSearchMaxResults = 6;
